import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import constants from '../utils/constants';

const ApprovedGuard = (props) => {
  const { children } = props;
  const { user } = useAuth();

  if (user.userStatus === constants.userStatus.APPROVED) {
    return (
      children
    );
  }

  return <Navigate to="/NeedApprovement" />;
};

ApprovedGuard.propTypes = {
  children: PropTypes.node
};

export default ApprovedGuard;
